import { BookPaymentServiceItemStruct } from "../../structs/book-payment-service-item.struct";

export class BookPaymentServiceRequest {
  idBookVersion!: number;
  idPaymentMethodInstallment?: number;
  listService: BookPaymentServiceItemStruct[] = [];
}
